// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/customer_memo.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GetStaffResponse } from "./staff_pb";
import { file_api_proto_v1_staff } from "./staff_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/customer_memo.proto.
 */
export const file_api_proto_v1_customer_memo: GenFile = /*@__PURE__*/
  fileDesc("CiBhcGlfcHJvdG8vdjEvY3VzdG9tZXJfbWVtby5wcm90bxIMYXBpX3Byb3RvLnYxIlgKGUNyZWF0ZUN1c3RvbWVyTWVtb1JlcXVlc3QSDAoEbWVtbxgBIAEoCRITCgtjdXN0b21lcl9pZBgCIAEoAxIYChBjb21wYW55X3N0YWZmX2lkGAMgASgDIjUKGVVwZGF0ZUN1c3RvbWVyTWVtb1JlcXVlc3QSCgoCaWQYASABKAMSDAoEbWVtbxgCIAEoCSInChlEZWxldGVDdXN0b21lck1lbW9SZXF1ZXN0EgoKAmlkGAEgASgDIjEKGkdldEN1c3RvbWVyTWVtb0xpc3RSZXF1ZXN0EhMKC2N1c3RvbWVyX2lkGAEgASgDIioKHFRvZ2dsZVBpbkN1c3RvbWVyTWVtb1JlcXVlc3QSCgoCaWQYASABKAMi1wEKFEN1c3RvbWVyTWVtb1Jlc3BvbnNlEgoKAmlkGAEgASgDEgwKBG1lbW8YAiABKAkSDgoGcGlubmVkGAMgASgIEjUKEXJlZ2lzdHJhdGlvbl9kYXRlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgthcHBfdXBkYXRlZBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLQoFc3RhZmYYBiABKAsyHi5hcGlfcHJvdG8udjEuR2V0U3RhZmZSZXNwb25zZSJQChtHZXRDdXN0b21lck1lbW9MaXN0UmVzcG9uc2USMQoFbWVtb3MYASADKAsyIi5hcGlfcHJvdG8udjEuQ3VzdG9tZXJNZW1vUmVzcG9uc2VCM1oxZ2l0aHViLmNvbS9oLXNjYXBlL2llc2FwdXJpL2dvL2FwaV9wcm90by92MTthcGl2MWIGcHJvdG8z", [file_api_proto_v1_staff, file_google_protobuf_timestamp]);

/**
 * @generated from message api_proto.v1.CreateCustomerMemoRequest
 */
export type CreateCustomerMemoRequest = Message<"api_proto.v1.CreateCustomerMemoRequest"> & {
  /**
   * @generated from field: string memo = 1;
   */
  memo: string;

  /**
   * @generated from field: int64 customer_id = 2;
   */
  customerId: bigint;

  /**
   * @generated from field: int64 company_staff_id = 3;
   */
  companyStaffId: bigint;
};

/**
 * Describes the message api_proto.v1.CreateCustomerMemoRequest.
 * Use `create(CreateCustomerMemoRequestSchema)` to create a new message.
 */
export const CreateCustomerMemoRequestSchema: GenMessage<CreateCustomerMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_memo, 0);

/**
 * @generated from message api_proto.v1.UpdateCustomerMemoRequest
 */
export type UpdateCustomerMemoRequest = Message<"api_proto.v1.UpdateCustomerMemoRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string memo = 2;
   */
  memo: string;
};

/**
 * Describes the message api_proto.v1.UpdateCustomerMemoRequest.
 * Use `create(UpdateCustomerMemoRequestSchema)` to create a new message.
 */
export const UpdateCustomerMemoRequestSchema: GenMessage<UpdateCustomerMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_memo, 1);

/**
 * @generated from message api_proto.v1.DeleteCustomerMemoRequest
 */
export type DeleteCustomerMemoRequest = Message<"api_proto.v1.DeleteCustomerMemoRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteCustomerMemoRequest.
 * Use `create(DeleteCustomerMemoRequestSchema)` to create a new message.
 */
export const DeleteCustomerMemoRequestSchema: GenMessage<DeleteCustomerMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_memo, 2);

/**
 * @generated from message api_proto.v1.GetCustomerMemoListRequest
 */
export type GetCustomerMemoListRequest = Message<"api_proto.v1.GetCustomerMemoListRequest"> & {
  /**
   * @generated from field: int64 customer_id = 1;
   */
  customerId: bigint;
};

/**
 * Describes the message api_proto.v1.GetCustomerMemoListRequest.
 * Use `create(GetCustomerMemoListRequestSchema)` to create a new message.
 */
export const GetCustomerMemoListRequestSchema: GenMessage<GetCustomerMemoListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_memo, 3);

/**
 * @generated from message api_proto.v1.TogglePinCustomerMemoRequest
 */
export type TogglePinCustomerMemoRequest = Message<"api_proto.v1.TogglePinCustomerMemoRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.TogglePinCustomerMemoRequest.
 * Use `create(TogglePinCustomerMemoRequestSchema)` to create a new message.
 */
export const TogglePinCustomerMemoRequestSchema: GenMessage<TogglePinCustomerMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_memo, 4);

/**
 * @generated from message api_proto.v1.CustomerMemoResponse
 */
export type CustomerMemoResponse = Message<"api_proto.v1.CustomerMemoResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string memo = 2;
   */
  memo: string;

  /**
   * @generated from field: bool pinned = 3;
   */
  pinned: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp registration_date = 4;
   */
  registrationDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp app_updated = 5;
   */
  appUpdated?: Timestamp;

  /**
   * @generated from field: api_proto.v1.GetStaffResponse staff = 6;
   */
  staff?: GetStaffResponse;
};

/**
 * Describes the message api_proto.v1.CustomerMemoResponse.
 * Use `create(CustomerMemoResponseSchema)` to create a new message.
 */
export const CustomerMemoResponseSchema: GenMessage<CustomerMemoResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_memo, 5);

/**
 * @generated from message api_proto.v1.GetCustomerMemoListResponse
 */
export type GetCustomerMemoListResponse = Message<"api_proto.v1.GetCustomerMemoListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CustomerMemoResponse memos = 1;
   */
  memos: CustomerMemoResponse[];
};

/**
 * Describes the message api_proto.v1.GetCustomerMemoListResponse.
 * Use `create(GetCustomerMemoListResponseSchema)` to create a new message.
 */
export const GetCustomerMemoListResponseSchema: GenMessage<GetCustomerMemoListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer_memo, 6);

